import { getLinkNum as getLinkNumApi } from '@/api/activity'
import { store } from './index'
import type { BaseMenuItem, LinkNums } from '@/api/activity/type'
export const useTabbarStore = defineStore(
  'APP_TAB_BAR',
  () => {
    // 刷新tabbar
    const isRefreshTabbar = ref(true)
    const route = useRoute()
    const router = useRouter()
    const { t } = useI18n()
    const menuList = ref<BaseMenuItem[]>([])
    const activeKey = ref('')
    const baseMenu = computed<BaseMenuItem[]>(() => {
      return [
        {
          name: t('page.activity.myEvalution'),
          code: 'evaluation',
          key: 'testLinkNum'
        },
        {
          name: t('page.activity.myRemark'),
          code: 'remarking',
          key: 'markLinkNum'
        },
        {
          name: t('page.activity.myInterview'),
          code: 'interview',
          key: 'interviewLinkNum'
        },
        {
          name: t('page.activity.myReview'),
          code: 'review',
          key: 'infoLinkNum'
        }
      ]
    })

    const getLinkNum = async (validLinkNumMap?: LinkNums) => {
      let data: LinkNums | undefined = validLinkNumMap
      if (!validLinkNumMap) {
        data = await getLinkNumApi()
      }
      if (!data) return
      isRefreshTabbar.value = false
      menuList.value = unref(baseMenu).filter((item) => data[item.key] && data[item.key] > 0)
      if (menuList.value.length > 0) {
        const isRightRoute = menuList.value.some((item) => item.code === route.name)
        if (!isRightRoute) {
          router.replace({ name: menuList.value[0].code })
          activeKey.value = menuList.value[0].code
        } else {
          activeKey.value = route.name as string
        }
      } else {
        router.replace({ name: 'evaluation' })
      }
    }
    const backHomePage = () => {
      isRefreshTabbar.value = true
      router.push({ name: 'activity' })
    }
    return {
      baseMenu,
      menuList,
      activeKey,
      isRefreshTabbar,
      getLinkNum,
      backHomePage
    }
  },
  {
    persist: false
  }
)

export function useTabbarStoreWithOut() {
  return useTabbarStore(store)
}
